module.exports = "./img/86ae74b1fc1fa0e5e4d1e39f4888bdcc.jpg";